export default __webpack_public_path__ + "static/media/36I-114289_-21019_0.dd22b61f.jpg";